import React, { FC, useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_COMPAIGN } from '../../graphql/compaign/query';
import {
  Compaign,
  CompaignVariables,
} from '../../graphql/compaign/types/Compaign';
import { Avatar, Box, Chip, Typography } from '@material-ui/core';
import useStyles from './styles';
import moment from 'moment';
import { formatName } from '../../utils/common';
import { HeaderContent } from '../../common/components/CustomChatRoom/CustomBubble/CustomBubble';

interface ICompaignDetails {
  compaignId?: number;
}

const CompaignDetails: FC<ICompaignDetails> = (props) => {
  const { compaignId } = props;

  const classes = useStyles();

  const {
    data: compaign,
    loading: loadingCompaign,
    error: loadingError,
  } = useQuery<Compaign, CompaignVariables>(GET_COMPAIGN, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        compaignId,
      },
    },
  });

  const ListItems = useMemo(
    () =>
      compaign?.compaign?.users?.map((user) => (
        <Chip
          avatar={<Avatar alt="" src={user?.avatarUrl ?? ''} />}
          label={formatName({
            firstName: user?.firstName,
            lastName: user?.lastName,
          })}
        />
      )),
    [compaign],
  );

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.bubble}>
        <HeaderContent title={compaign?.compaign?.title ?? ''} />
        <Box display="flex" flexDirection="column">
          <Typography variant="body1" gutterBottom className={classes.message}>
            {compaign?.compaign?.message?.content?.text ?? 'Message vide'}
          </Typography>
          <Typography className={classes.time}>
            {moment(compaign?.compaign?.createdAt).calendar({
              sameDay: 'hh:mm',
              lastDay: '[Hier]',
              lastWeek: 'Do MMM',
              sameElse: 'Do MMM',
            })}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.chips}>{ListItems}</Box>
    </Box>
  );
};

export default CompaignDetails;
